import React, {useCallback, useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import {DialogTitle, Divider, Stack, Typography} from '@mui/material';
import {makeStyles} from '@mui/styles';
import {FiAlertTriangle} from 'react-icons/fi';
import PropTypes from 'prop-types';
import UploadAksi from '../Component/UploadAksi';
import {useDropzone} from 'react-dropzone';
import {CloseOutlined} from '@mui/icons-material';
import {FETCH_ERROR} from 'shared/constants/ActionTypes';
import FileRow from '../Component/FileRow';
import {useDispatch} from 'react-redux';
import { onImportAksiPerubahan } from 'redux/actions/AksiPerubahan';

const useStyles = makeStyles({
  table: {
    border: 'none',
    '& th, & td': {
      border: 'none', // Remove cell borders
      padding: '12px',
    },
    '&:nth-child(1)': {
      width: '50%',
    },
    '&:nth-child(2)': {
      width: '1%',
    },
  },
  lighterCell: {
    color: '#6B7280',
    border: 0,
  },
});

const DialogImport = ({open, onClickClose, onClickImport}) => {
  const classes = useStyles();
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const dispatch = useDispatch();

  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    if (fileRejections.length !== 0 && acceptedFiles.length === 0) {
      dispatch({
        type: FETCH_ERROR,
        payload: 'Tipe File Tidak Mendukung',
      });
    } else {
      setUploadedFiles(null);
      const size = (acceptedFiles[0].size / 1024 / 1024).toFixed(3);
      if (size <= 50) {
        // dispatch(onAddAttachmentDigisign('onDrop', acceptedFiles[0]))
        setUploadedFiles({
          name: acceptedFiles[0].name,
          type: acceptedFiles[0].type,
          size: acceptedFiles[0].size,
          file: acceptedFiles[0],
        });
      } else {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Ukuran File Maksimal 50 MB',
        });
      }
    }
  }, []);
  const {getRootProps, getInputProps} = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      'application/': ['.csv','.xlsx'],
    },
  });

  const onDeleteUploadFile = (file) => {
        setUploadedFiles(null)
  };

  const handleImport = () => { 

    if(uploadedFiles){

        var file = new File([uploadedFiles.file], uploadedFiles.name, { type: uploadedFiles.type, path: uploadedFiles.name });
        dispatch(onImportAksiPerubahan(uploadedFiles.file))

    }
   }

  return (
    <div>
      <Dialog
        open={open}
        sx={{
          '& .MuiDialog-paper': {
            maxWidth: '800px !important',
            width: '750px',
            height: '485px',
            padding: '5px',
            borderRadius: '16px',
          },
        }}
      >
        <DialogContent>
          <DialogTitle sx={{display: 'flex', justifyContent: 'space-between'}}>
            <Typography sx={{fontWeight: '600', fontSize: '18px'}}>
              Import Aksi Perubahan
            </Typography>
            <CloseOutlined onClick={onClickClose} />
          </DialogTitle>
          <Divider sx={{marginY: 2}} />

          <DialogContentText>
           
            {uploadedFiles !== null ? (
              <FileRow
                key={uploadedFiles.name}
                file={uploadedFiles}
                onDeleteUploadFile={onDeleteUploadFile}
              />
            ) : (
              <UploadAksi
                uploadText='Seret dan jatuhkan unggah file  dalam format Excel file di sini, atau klik untuk memilih file'
                getRootProps={getRootProps({className: 'dropzone'})}
                getInputProps={getInputProps()}
                height='265px'
              />
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClickClose}
            variant='contained'
            size='small'
            style={{
              width: '100px',
              backgroundColor: '#F5F5F5',
              color: '#9F9F9F',
            }}
          >
            BATAL
          </Button>
          <Button
            onClick={handleImport}
            variant='contained'
            size='small'
            style={{width: '100px', backgroundColor: '#800000'}}

          >
            IMPORT
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DialogImport;

DialogImport.propTypes = {
  open: PropTypes.any,
  onClickClose: PropTypes.func,
  onClickImport: PropTypes.func,
};
